import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useStatusErrors } from "../../hooks";
import { Modal } from "antd";
import { __ } from "../../utils";
import { ErrorModalList } from ".";
const ErrorModal = ()=>{
    const { errors } = useStatusErrors();
    const [visible, setVisible] = useState(false);
    useEffect(()=>{
        const { activeElement } = document;
        const hasErrors = Object.values(errors).length > 0;
        if (hasErrors) {
            if (activeElement && (/^(?:input|select|textarea|button)$/i.test(activeElement.nodeName) || activeElement.hasAttribute("contenteditable"))) {
                setVisible(false);
                const listener = ()=>{
                    setVisible(true);
                };
                activeElement.addEventListener("blur", listener, {
                    once: true
                });
                return ()=>{
                    activeElement.removeEventListener("blur", listener);
                };
            } else {
                setVisible(true);
            }
        } else {
            setVisible(false);
        }
        return ()=>{
        // Silence is golden.
        };
    }, [
        errors
    ]);
    return /*#__PURE__*/ _jsx(Modal, {
        className: "real-queue-error-modal",
        footer: null,
        title: __("Background tasks: Something went wrong"),
        open: visible,
        width: 750,
        closable: false,
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "description",
                    children: __("Your WordPress installation is working in the background on tasks that you basically don't notice. Unfortunately, an error occurred while running a task. Below is a list of failed tasks that you can either delete (and thus cancel the task) or try again.")
                }),
                /*#__PURE__*/ _jsx(ErrorModalList, {
                    list: errors
                })
            ]
        })
    });
};
export { ErrorModal };
